import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import store from '../../store';
import { MODAL_OPTIONS_EPISODES, showModal } from '../../actions/modal';
import 'src/components/Modal/styles/ModalKeepWatching.scss';
import { RouteComponentProps } from 'react-router';
import { setValuesStoreModalKeepWatching } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import { playFullMedia } from 'src/actions/playmedia';
import LayersControl from 'src/utils/LayersControl';
import AAFPlayer from 'src/AAFPlayer/AAFPlayer';
interface IProps {
    groupId: string;
    dataAfterBack?: object;
}
interface IPropsButtons {
    variant: string;
    onClick: () => void;
}
interface IButtons {
    content: string;
    extraClass: string;
    props: IPropsButtons;
}
interface IParams {
    classNameComponent: string;
    showLogo: boolean;
    aafNewStyle: boolean;
    alwaysEnabled: boolean;
    buttonsAlign: string;
    className: string;
    content: string;
    subtitle: string;
    buttons: IButtons[];
    handlerBack?: () => void;
}

class ModalKeepWatching extends Component<RouteComponentProps & IProps> {
    extraClass: string;
    variant: string;
    params: IParams;
    setTimeOutModal: string;
    idFocusOnShortcut: string;

    constructor(props: RouteComponentProps & IProps) {
        super(props);
        this.extraClass = 'btn-modal-bookmark';
        this.variant = 'dark';
        this.closeModal = this.closeModal.bind(this);
        this.redirectRegister = this.redirectRegister.bind(this);
        this.redirectLogin = this.redirectLogin.bind(this);
        this.redirectCancel = this.redirectCancel.bind(this);
        this.handlerBack = this.handlerBack.bind(this);
        this.params = {
            handlerBack: this.handlerBack,
            classNameComponent: 'modal-keep-watching',
            showLogo: true,
            aafNewStyle: true,
            alwaysEnabled: true,
            buttonsAlign: 'vertical',
            className: 'aaf-modal aaf-modal-error',
            content: Translator.get('keepWatching_modal_title_label', 'Continúa viendo'),
            subtitle: Translator.get(
                'keepWatching_modal_description_label',
                'Para continuar viendo este contenido iniciá sesión o registrate.'
            ),
            buttons: [
                {
                    content: Translator.get('keepWatching_option_button_register', 'REGÍSTRATE'),
                    extraClass: `${this.extraClass} modal-keep-watching__button-register`,
                    props: {
                        variant: this.variant,
                        onClick: this.redirectRegister,
                    },
                },
                {
                    content: Translator.get('keepWatching_option_button_login', 'INICIAR SESIÓN'),
                    extraClass: `${this.extraClass} modal-keep-watching__button-login`,
                    props: {
                        variant: this.variant,
                        onClick: this.redirectLogin,
                    },
                },
                {
                    content: Translator.get('keepWatching_option_button_cancel', 'CANCELAR'),
                    extraClass: `${this.extraClass} modal-keep-watching__button-cancel`,
                    props: {
                        variant: this.variant,
                        onClick: this.redirectCancel,
                    },
                },
            ],
        };
    }

    finishPlaying() {
        store.dispatch(
            playFullMedia({
                playerstate: 'STOPPING',
                ispreview: false,
                islive: false,
                ispip: false,
            })
        );
        LayersControl.showUX();
    }

    closeModal = () => {
        store.dispatch(
            showModal({
                modalType: 'HIDE_MODAL',
                modalProps: {},
            })
        );
    };

    redirectRegister = () => {
        this.props.history.push('/register', {from: 'modalKeepWatch'});
        this.finishPlaying();
        this.closeModal();
    };

    redirectLogin = () => {
        this.props.history.push('/login');
        this.finishPlaying();
        this.closeModal();
    };

    redirectCancel = () => {
        this.handlerBack();
    };

    handlerBack() {
        const { modalPropsOptionsEpisodes = null } = store.getState().modalKeepWatching;

        setValuesStoreModalKeepWatching({
            comeThisModal: false,
            groupId: '',
            nextGroupId: '',
        });

        const modal = {
            modalType: MODAL_OPTIONS_EPISODES,
            modalProps: modalPropsOptionsEpisodes,
        };

        modal.modalProps.dataAfterBack = this.props.dataAfterBack;

        let isPlaying = AAFPlayer.isPlayerPlaying();

        if(isPlaying) {
            modalPropsOptionsEpisodes && store.dispatch(showModal(modal));
        } else {
            this.closeModal();
            this.props.history.replace(`/vcard/${this.props.groupId}`)
        }
    }

    componentDidMount(): void {
        setValuesStoreModalKeepWatching({ comeThisModal: true, groupId: this.props.groupId });
    }

    render() {
        return <ModalWrapper {...this.params} />;
    }
}

export default withOnClose(ModalKeepWatching);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalKeepWatching.tsx